// HẠN MỨC RIÊNG MỖI NGÀY theo LOẠI VIỆC (BundleStep.dem_ngay) — 07/10/2026 (thao tác xây kênh mới: theo dõi / chia sẻ / đăng bài kênh / tin nhắn / hồ sơ).
// Trước đây chỉ có "tham_gia_nhom" (Cài đặt thamGiaNhomMoiNgay, mặc định 3). Mỗi loại đếm RIÊNG theo nick (src/background/runner.ts danhTinhHanMuc) và
// VẪN tính chung vào hạn mức việc mỗi ngày (hanMucMoiNgay). Hết lượt → bỏ phần còn lại của bước (không phải lỗi), các bước sau vẫn chạy.
// Bundle có dem_ngay KHÁC "tham_gia_nhom" tự khai can_plugin (phien-ban-plugin.ts PLUGIN_CAN_KENH_MOI): plugin cũ chỉ biết tham_gia_nhom → bỏ qua lặng lẽ (theo dõi
// không giới hạn) → Boss không giao cho bot cũ.

// (08/10/2026, đợt B mục 1) + binh_luan / tra_loi / trich_dan — đếm theo nick + MẠNG (phạm vi = tên miền@nick nên mỗi mạng một bộ đếm riêng). Bundle KHÔNG cần khai dem_ngay:
// runner SUY loại từ sổ cái của bước gửi (loaiDemCuaBuoc) → kịch bản cũ không đổi YAML/hash mà vẫn có hạn mức. Hạn RIÊNG của một bước (BundleStep.han_ngay — ô "Tối đa mỗi ngày"
// trên sơ đồ) thắng hạn của lịch (RunRecord.hanMuc — đợt B mục 7) thắng Cài đặt.
export const LOAI_DEM_NGAY = ["tham_gia_nhom", "theo_doi", "chia_se", "dang_bai_kenh", "tin_nhan", "ho_so", "binh_luan", "tra_loi", "trich_dan"] as const;
export type LoaiDemNgay = (typeof LOAI_DEM_NGAY)[number];

export interface CauHinhHanMucNgay {
  /** Khoá trong Cài đặt plugin (Settings) — không đặt thì dùng macDinh. */
  caiDat: "thamGiaNhomMoiNgay" | "theoDoiMoiNgay" | "chiaSeMoiNgay" | "dangBaiKenhMoiNgay" | "tinNhanMoiNgay" | "hoSoMoiNgay" | "binhLuanMoiNgay" | "traLoiMoiNgay" | "trichDanMoiNgay";
  macDinh: number;
  /** Động từ quá khứ cho câu báo: "đã <viec> 3/10 <donVi>". */
  viec: string;
  donVi: string;
}

// Mặc định THẬN TRỌNG (mạng xã hội coi theo dõi/nhắn tin hàng loạt là spam): theo dõi 10, chia sẻ/đăng lại 5, đăng bài lên kênh 3, trả lời tin nhắn 5, sửa hồ sơ 1.
export const HAN_MUC_NGAY: Readonly<Record<LoaiDemNgay, CauHinhHanMucNgay>> = {
  tham_gia_nhom: { caiDat: "thamGiaNhomMoiNgay", macDinh: 3, viec: "tự tham gia", donVi: "nhóm" },
  theo_doi: { caiDat: "theoDoiMoiNgay", macDinh: 10, viec: "theo dõi / đăng ký / tham gia", donVi: "tài khoản / kênh / cộng đồng" },
  chia_se: { caiDat: "chiaSeMoiNgay", macDinh: 5, viec: "chia sẻ / đăng lại", donVi: "bài" },
  dang_bai_kenh: { caiDat: "dangBaiKenhMoiNgay", macDinh: 3, viec: "đăng", donVi: "bài lên kênh / tường / cộng đồng" },
  tin_nhan: { caiDat: "tinNhanMoiNgay", macDinh: 5, viec: "trả lời", donVi: "tin nhắn" },
  ho_so: { caiDat: "hoSoMoiNgay", macDinh: 1, viec: "sửa hồ sơ", donVi: "lần" },
  // Mặc định (người dùng, kịch bản seeding 7 ngày): ~8–10 bình luận / trả lời mỗi mạng mỗi ngày; trích dẫn ít hơn (X coi trích dẫn dồn dập là spam).
  binh_luan: { caiDat: "binhLuanMoiNgay", macDinh: 10, viec: "bình luận", donVi: "bình luận" },
  tra_loi: { caiDat: "traLoiMoiNgay", macDinh: 10, viec: "trả lời", donVi: "câu trả lời" },
  trich_dan: { caiDat: "trichDanMoiNgay", macDinh: 3, viec: "trích dẫn", donVi: "bài" },
};

export function laLoaiDemNgay(x: unknown): x is LoaiDemNgay {
  return typeof x === "string" && (LOAI_DEM_NGAY as readonly string[]).includes(x);
}

/**
 * Loại đếm của một bước: `dem_ngay` khai rõ (hợp lệ) thắng; không khai → SUY từ sổ cái của bước gửi (bình luận / trả lời / trích dẫn).
 * Sổ cái "da_tra_loi_tn*" (tin nhắn) đã khai dem_ngay tin_nhan nên không rơi vào nhánh suy. Không thuộc loại nào → null (không đếm riêng).
 */
export function loaiDemCuaBuoc(s: { dem_ngay?: unknown; ledger?: unknown; id?: unknown; risk?: unknown }): LoaiDemNgay | null {
  if (s.dem_ngay !== undefined) return laLoaiDemNgay(s.dem_ngay) ? s.dem_ngay : null;
  const l = typeof s.ledger === "string" ? s.ledger : "";
  if (/^da_binh_luan(?:_|$)/.test(l)) return "binh_luan";
  if (/^da_tra_loi(?:_|$)/.test(l) && !/^da_tra_loi_tn(?:_|$)/.test(l)) return "tra_loi";
  if (/^da_trich_dan(?:_|$)/.test(l)) return "trich_dan";
  // X "Đăng bài mới" (x-khoi.ts dang_bai — không sổ cái): bước gửi rủi ro cao mang id dang_bai (lần n: dang_bai_n) → đăng bài lên kênh. Suy ở đây để bundle cũ không đổi hash.
  if (!l && (s as { risk?: unknown }).risk === "high" && /^dang_bai(?:_\d+)?$/.test(String((s as { id?: unknown }).id ?? ""))) return "dang_bai_kenh";
  return null;
}

/** Hạn mức hiệu lực của một loại: số nguyên ≥ 0 từ Cài đặt; không hợp lệ / không đặt → mặc định. */
export function hanMucNgayCua(loai: LoaiDemNgay, caiDat: Partial<Record<CauHinhHanMucNgay["caiDat"], unknown>>): number {
  const cfg = HAN_MUC_NGAY[loai];
  const v = caiDat[cfg.caiDat];
  return typeof v === "number" && Number.isFinite(v) ? Math.max(0, Math.floor(v)) : cfg.macDinh;
}

/** Trần kỹ thuật của hạn một bước / một lịch (một năm có 365 ngày — số lớn hơn là nhập nhầm). */
export const HAN_NGAY_TOI_DA = 365;
/** Số nguyên ≥ 0 (số, hoặc chữ số — kể cả "3.7" → 3) ≤ HAN_NGAY_TOI_DA; khác (âm, chữ, rỗng, {{…}} chưa thay, quá lớn) → null. */
export function soHanNgay(v: unknown): number | null {
  const n = typeof v === "number" ? v : typeof v === "string" && /^\s*\d+(?:\.\d+)?\s*$/.test(v) ? Number(v) : NaN;
  if (!Number.isFinite(n) || n < 0 || n > HAN_NGAY_TOI_DA) return null;
  return Math.floor(n);
}
/** Hạn hiệu lực: hạn của BƯỚC (han_ngay) > hạn của LỊCH (ghiDe — đợt B mục 7) > Cài đặt > mặc định. Giá trị sai ở tầng nào thì bỏ qua tầng đó. */
export function hanMucHieuLuc(loai: LoaiDemNgay, caiDat: Partial<Record<CauHinhHanMucNgay["caiDat"], unknown>>, hanBuoc: unknown, ghiDe?: Partial<Record<LoaiDemNgay, unknown>> | null): number {
  const b = soHanNgay(hanBuoc);
  if (b !== null) return b;
  const l = ghiDe ? soHanNgay(ghiDe[loai]) : null;
  if (l !== null) return l;
  return hanMucNgayCua(loai, caiDat);
}

/** (đợt B mục 7) Hạn mức RIÊNG của một lịch: { loại: số nguyên 0–365 }. null/undefined/{} → undefined (không đặt); sai → { loi } (câu tiếng Việt). */
export function docHanMucLich(v: unknown): { hanMuc?: Partial<Record<LoaiDemNgay, number>> } | { loi: string } {
  if (v === undefined || v === null) return {};
  const tien = "Hạn mức riêng của lịch";
  if (typeof v !== "object" || Array.isArray(v)) return { loi: `${tien} phải là một đối tượng {loại việc: số mỗi ngày}` };
  const ra: Partial<Record<LoaiDemNgay, number>> = {};
  for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
    if (!laLoaiDemNgay(k)) return { loi: `${tien}: không có loại việc “${k.slice(0, 40)}” — chỉ nhận: ${LOAI_DEM_NGAY.join(", ")}` };
    if (typeof x !== "number" || !Number.isInteger(x) || x < 0 || x > HAN_NGAY_TOI_DA) return { loi: `${tien}: “${HAN_MUC_NGAY[k].viec} ${HAN_MUC_NGAY[k].donVi}” phải là số nguyên 0–${HAN_NGAY_TOI_DA} mỗi ngày` };
    ra[k] = x;
  }
  return Object.keys(ra).length ? { hanMuc: ra } : {};
}

/** Câu báo khi hết lượt (loại khác tham_gia_nhom — câu của tham_gia_nhom giữ nguyên chữ cũ trong runner). */
export function lyDoHetLuotNgay(loai: LoaiDemNgay, nhan: string, da: number, han: number, moPhong: string): string {
  const c = HAN_MUC_NGAY[loai];
  if (han === 0) return `hạn mức mỗi ngày cho việc ${c.viec} ${c.donVi} đang là 0 — không làm việc này${moPhong}`;
  return `hôm nay ${nhan} đã ${c.viec} ${da}/${han} ${c.donVi} (hạn mức mỗi ngày) — đủ hạn mức hôm nay: bỏ qua phần còn lại của bước này, vẫn tiếp tục các bước sau (không phải lỗi)${moPhong}`;
}
